import React from 'react';
import { DownloadResourceProviders } from '../hooks/useDownloadPriceListHandler';
import FileItem, { IPriceListItem } from './FileItem';
import useStyles from './FileList.styles';

interface IFileListProps {
  fileItems: IPriceListItem[];
  priceListLabels?: any;
  downloadProvider?: DownloadResourceProviders;
}

const FileList = ({ fileItems, priceListLabels, downloadProvider }: IFileListProps) => {
  const classes = useStyles();
  return (
    <div className={classes.FileList}>
      {fileItems.map((item) => (
        <FileItem
          {...item}
          key={item.label}
          priceListLabels={priceListLabels}
          downloadProvider={downloadProvider}
        />
      ))}
    </div>
  );
};

export default FileList;
